export const stringToCategoryTag = (str: string): string =>
  str?.trim().replace(/ /g, '-').toLowerCase();
